import { handleActions } from 'redux-actions';
import {
  CONFIRM_DIALOG_OPEN,
  CONFIRM_DIALOG_CLOSE
} from '../actions/uiConfirmDialog';


const defaultState = {confirmDialogOpen: false, title: ""};

export default handleActions({

  [CONFIRM_DIALOG_OPEN]: (state, action) => {
    return {
      confirmDialogOpen: true,
      title: action.payload.title,
      message: action.payload.message,
      onOk: action.payload.onOk,
      noMessage: action.payload.noMessage,
      YesNessage: action.payload.YesNessage,
    };
  },
  [CONFIRM_DIALOG_CLOSE]: (state, action) => {
    return {
      confirmDialogOpen: false,
      title: "",
    };
  },
}, defaultState)

